// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xSwiperStickyDots } from "@pace/App/Components/XngCarousel";
import { BannerCarousalStyles } from "@pace/App/Widgets/BannerCarousel/BannerCarousel";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

// XNG-Changes:PAC-928
BannerCarousalStyles.carouselWrapper = {
    container: {
        css: css`
            isolation: isolate;
            ${xScreen("gte", "lg")} {
                ${xSwiperStickyDots}
            }
            &&&& {
                .dots-with-numbers {
                    color: ${color("common.ui1")};
                }
                .swiper-pagination-bullet-active {
                    color: ${color("secondary.main")};
                    ${xScreen("lte", "md")} {
                        background: ${color("primary.main")};
                        color: ${color("common.ui1")};
                        border: 1px solid ${color("primary.main")};
                    }
                }
                ${xScreen("lte", "md")} {
                    .swiper-pagination-bullet {
                        &:not(.swiper-pagination-bullet-active) {
                            color: ${color("common.ui12")};
                            border: 1px solid ${color("common.ui12")};
                        }
                        &:hover:not(.swiper-pagination-bullet-active) {
                            color: ${color("common.ui1")};
                            background: ${color("common.ui12")};
                        }
                    }
                }
            }
        `,
    },
};

BannerCarousalStyles.itemWrapper = {
    width: 12,
    css: css`
        padding: 0;
        ${xScreen("lt", "md")} {
            height: 100%;
        }
    `,
};

const containerFlex = `
    display: flex;
    width: 100%;
`;

BannerCarousalStyles.slideImageAndContentWrapper = {
    css: css`
        ${containerFlex}
        border-radius: 4px;
        height: 464px;
        overflow: hidden;
        ${({ isReversed, backgroundColor }: any) => `
                flex-direction: ${isReversed ? "row-reverse" : "row"};
                background-color: ${backgroundColor};
            `}

        ${xScreen("lt", "md")} {
            flex-direction: column-reverse;
            height: 100%;
            justify-content: flex-end;
        }
    `,
};

BannerCarousalStyles.slideContentWrapper = {
    css: css`
        ${containerFlex}
        flex-direction: column;
        padding: 32px;
        gap: 16px;
        overflow: hidden;
        box-sizing: border-box;
        ${({ color = "#000" }: any) => `
            color: ${color};
        `}

        ${xScreen("lt", "sm")} {
            padding: 16px;
        }
    `,
};

BannerCarousalStyles.slideButton = {
    css: css`
        width: fit-content;
        margin-top: 4px;
    `,
};

BannerCarousalStyles.slideImageContainer = {
    css: css`
        ${containerFlex}
        justify-content: center;
        align-items: center;
        background: transparent;
        overflow: hidden;
        ${({ fullHeight }: any) => (fullHeight ? "flex: 0 0 678px;" : "")}
        img {
            min-width: ${({ fullHeight }: any) => (fullHeight ? "678px" : "400px")};
        }
        img,
        picture {
            ${({ fullHeight }: any) => (fullHeight ? "height: 100%; width: 100%;" : "")}
        }
        ${xScreen("lt", "md")} {
            flex: 1;
            img {
                max-height: 224px;
                min-width: unset;
                object-fit: cover;
            }
        }
    `,
};

BannerCarousalStyles.slideTitle = {
    size: 38,
    lineHeight: "46px",
    css: css`
        font-weight: 900;
        margin-bottom: 0;
    `,
};

BannerCarousalStyles.slideSubTitle = {
    weight: fontConfig.weight.regular,
    css: css`
        &,
        & > :last-child {
            margin-bottom: 0;
        }
        ul {
            padding: 0 0 0 20px;
            line-height: 26px;
        }
        li {
            line-height: 26px;
            font-size: 16px;
            font-weight: ${fontConfig.weight.regular};
            margin: 0; /* rid-off default margins */
            &:not(:last-of-type) {
                margin: 0 0 8px 0;
            }
        }
    `,
};
